<template>
  <div class="ielts-page">
    <section class="masthead hero-text-img-section section-bottom-spacing">
      <div class="container-fluid px-0">
        <div class="row justify-content-center mt-5 border-20">
          <div class="col-lg-6 text-center">
            <h2 class="secondary-color">IELTS</h2>
            <!-- <h2 class="page-intro-line">Crack that perfect band score!</h2> -->
            <h2 class="page-intro-line">Achieve the Perfect Band Score</h2>
            <p class="main-content-1 mt-2">
              <!-- Let's help you pave the roadmap to attain the IELTS score of your
               -->
              Acing the IELTS is no more a distant dream
            </p>
          </div>
        </div>
      </div>
      <div class="hero-img ielts-hero mt-5">
        <img src="@/assets/imgs/ielt-hero-img.png" alt="" />
      </div>
      <!--npm
      <div class="intro-tabs">
        <p class="main-content-1 mt-2 text-center ptb-2">
          Test preparation and foreign languages all at one place
        </p>
        <ul class="tabs">
          <li class="tab-content">
            <img src="@/assets/imgs/coach-logo.png" alt="" />
          </li>
          <li class="tab-content">
            <img src="@/assets/imgs/Tofel.png" alt="" />
          </li>
          <li class="tab-content">
            <img src="@/assets/imgs/other-countries.png" alt="" />
          </li>
          <li class="tab-content">
            <img src="@/assets/imgs/PTE.png" alt="" />
          </li>
        </ul>
      </div> -->
    </section>

    <section class="masthead hero-text-img-section mt-5">
      <div class="py-xl-4 mx-lg-3 gradient-box bg-primary-gradient">
        <ul class="intro-data">
          <li class="data">
            <h1 class="data-title">3,500+</h1>
            <p class="data-summary pt-2">Students Registered</p>
          </li>
          <li class="data">
            <h1 class="data-title">91%</h1>
            <p class="data-summary pt-2">Students got their desired score</p>
          </li>
          <li class="data">
            <h1 class="data-title">40+</h1>
            <p class="data-summary pt-2">Years of team experience</p>
          </li>
          <li class="data">
            <h1 class="data-title">34+</h1>
            <p class="data-summary pt-2">Batches weekly</p>
          </li>
        </ul>
      </div>
    </section>

    <section class="process-section section-spacing">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="text-center">
              <h2 class="main-heading-1">
                <!-- 5 Big reasons, why you should couch at Aliff -->
                5 Compelling Reasons to Choose us as your Coaching Partner
              </h2>
            </div>
          </div>
        </div>
        <div class="row align-items-center mt-5">
          <div class="col-xl-5">
            <div class="text-center">
              <img src="@/assets/imgs/reasons.png" class="img-fluid" />
            </div>
          </div>
          <div class="offset-xl-1 col-xl-6 mt-4 mt-lg-0">
            <div>
              <ul class="list-item icon-list-item">
                <li>
                  <!-- We bring to you high quality, certified teachers with over 20+
                  years of experience -->
                  Our experienced and certified teachers have 20+ years of
                  expertise to offer you with high-quality education.
                </li>
                <li>
                  <!-- We are affordable, yet never compromise on the education we
                  bring your way -->
                  We offer affordable education without compromising on quality.
                </li>
                <li>
                  <!-- We do not take a cookie-cutter approach, but a personalized
                  unique method that is planned, keeping you in mind -->
                  We provide flexible coaching options for both weekend and
                  weekday batches.
                </li>
                <li>
                  <!-- Flexibility of coaching for weekend or weekdays batch -->
                  Our cohesive environment allows for mentoring and evaluation,
                  preparing you for the real-world tests.
                </li>
                <li>
                  <!-- We mentor & evaluate you in a cohesive environment to prepare
                  you for the real tests -->
                  Our personalized coaching approach caters to all your specific
                  needs.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- <div class="row align-items-center pt-5">
          <div class="col-md-6 order-md-2">
            <div class="text-center">
              <img src="@/assets/imgs/process-ielts.png" class="img-fluid" />
            </div>
          </div>
          <div class="col-md-6 col-xl-6 order-md-1 mt-3 mt-lg-0">
            <div>
              <h2 class="main-heading-1 w-50">The Process with allif</h2>
            </div>
            <div>
              <p class="main-content-1 mt-5">
                Enrolling with IELTS experts is a one-step process. Start now,
                right here!
              </p>
            </div>
            <div class="pt-3 pt-lg-5">
              <button
                class="btn-secondary-red"
                @click="$router.push({ path: '/contact-us' })"
              >
                Enquire Now
              </button>
            </div>
          </div>
        </div> -->
      </div>
    </section>
    <section class="student-section py-xl-5 my-5">
      <div class="container-fluid bg-row py-5">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center">
            <div class="main-heading-1">Hear from our students</div>
            <div class="main-content-1">
              Your thoughts inspire us. It is the fuel that pumps us to go that
              extra mile. Hear what some of our past students have to say about
              us
            </div>
          </div>
          <div class="col-lg-12 mt-5">
            <VideoTestimonialSlider
              :testimonialsData="testimonialData['ielts']['testimonial-2']"
            />
          </div>
          <div class="col-lg-12 mt-5 stu-card-section">
            <TextTestimonialSlider
              :testimonialsData="testimonialData['ielts']['testimonial-1']"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="pricing-section section-spacing">
      <div class="">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="text-center">
              <h2 class="main-heading-1">
                <!-- <b>Pricing to suit all sizes of budget</b> -->
                <b>Pricing according to your Budget</b>
              </h2>
              <p class="main-content-1 pt-5">
                <!-- We coach, without breaking the bank! It is not easy to find
                quality at a decent price tag. This is what many think is true.
                But that’s the reverse with us. We are here on a mission to give
                your dreams the necessary push and that does not come with a
                price. -->
                At Aliff, we believe that quality coaching should not break the
                bank. While many may think it's impossible to find affordable
                and high-quality coaching, we are here to prove them wrong. Our
                mission is to provide you with world-class education burdening
                your budget.
              </p>
            </div>
          </div>
          <div class="col-lg-12 pt-5">
            <div class="">
              <slick
                ref="pricingSlider"
                :options="pricingSlider"
                class="pricing-slider"
                v-if="service.plans && service.plans.length > 0"
              >
                <div
                  v-for="(plan, index) in service.plans"
                  :key="'plan_' + index"
                >
                  <div class="pricing-card ielts-card py-3 mb-2">
                    <div class="pricing-plan-name">{{ plan.plan_name }}</div>
                    <div class="pricing-cost mb-0">
                      {{
                        getSymbolFromCurrency(
                          plan.pp_currency
                            ? plan.pp_currency
                            : plan.plan_currency
                        )
                      }}
                      {{
                        addCommas(
                          plan.pp_price
                            ? removeGST(plan.pp_price, plan.pp_currency)
                            : removeGST(plan.plan_price, plan.plan_currency)
                        )
                      }}
                    </div>
                    <div
                      class="text-center mb-1"
                      style="color: #999"
                      v-if="
                        plan.plan_currency == 'INR' || plan.pp_currency == 'INR'
                      "
                    >
                      + 18% GST
                    </div>

                    <div class="course-summary">
                      <div v-html="plan.plan_description"></div>
                    </div>
                    <br /><br />

                    <div class="pricing-btn ielts-btn w-100">
                      <button class="btn btn-pay-now-gradient btn-here">
                        <a
                          href="http://app.aliff.in/?service_name=IELTS"
                          >Pay Now</a
                        >
                      </button>
                      <!-- @click="PayNow('pp' + (index + 3))" -->
                      <!-- <div class="plan-route" @click="clickShowPlan()">
                        View & Compare Plans
                      </div> -->
                    </div>
                  </div>
                </div>
              </slick>
            </div>
           
          </div>
        </div>
      </div>
    </section>

    <!-- <book-free-counselling
      text="Wondering what’s in it for you? Get in touch with us now!"
    /> -->

    <ContactusSection :source="23"/>

    <RecentPostSection
      :recentPostsData="recentPostData['ielts-page']['data-1']"
    />
  </div>
</template>

<script>
import homeServices from "@/apiServices/homeServices";
import BookFreeCounselling from "@/components/partials/BookFreeCounselling.vue";
import { DASHBOARD_REGISTER_URL } from "@/config";
import RecentPostSection from "@/components/partials/RecentPostSection.vue";
import VideoTestimonialSlider from "@/components/partials/VideoTestimonialSlider.vue";
import TextTestimonialSlider from "@/components/partials/TextTestimonialSlider.vue";
import ContactusSection from "@/components/partials/ContactusSection.vue";
import getSymbolFromCurrency from "currency-symbol-map";

export default {
  metaInfo: {
      title:
        "Achieve Top IELTS Scores with Aliff's Expert Preparation",
      htmlAttrs: {
        lang: "en-US",
      },
    },
  name: "Home",
  components: {
    BookFreeCounselling,
    RecentPostSection,
    VideoTestimonialSlider,
    TextTestimonialSlider,
    ContactusSection,
  },
  data() {
    return {
      service: [],
      showPlan: false,
      DASHBOARD_REGISTER_URL,
      videoSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 2.5,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      pricingSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      destinationSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      postSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      logoSlider: {
        autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 8,
        autoplaySpeed: 1000,
        centerMode: true,
        centerPadding: "30px",
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  methods: {
    getSymbolFromCurrency,
    removeGST(total, currency) {
      if (currency != "INR") {
        return total;
      }

      let taxPercentage = 0.18;
      let withTaxAmount = total / (1 + taxPercentage);
      return withTaxAmount.toFixed(0);
    },
    PayNow(pp) {
      var elms = document.getElementById(pp).getElementsByTagName("a");
      elms[0].click();
    },
    clickShowPlan() {
      this.showPlan = !this.showPlan;
    },
    // payNow(link, id) {
    //   const scriptEle = document.createElement("script");
    //   scriptEle.setAttribute("src", link);
    //   scriptEle.setAttribute("data-payment_button_id", id);
    //   scriptEle.setAttribute("async", true);

    //   console.log(this.$refs.myform);
    //   this.$refs.myform[0].appendChild(scriptEle);
    // },

    async getServicePlan() {
      try {
        const response = await homeServices.getServicesAndPlans({
          service_id: 6,
        });
        if (response.data.status) {
          this.service = response.data.data[0];
          console.log(this.service);
        }
      } catch (err) {
        console.log("Error in getting getServicePlan ", err);
      }
    },
    addCommas(amt) {
      return amt.toLocaleString("en-IN");
    },
  },
  created() {},
  mounted() {},
  beforeMount() {
    document.querySelector('meta[name="description"]').setAttribute('content',"Looking for expert IELTS preparation? Aliff offers comprehensive coaching with experienced instructors to help you ace your IELTS exam.");
    this.getServicePlan();
  },
};
</script>
<style>
.pricing-section .pricing-slider .slick-track{
  width: 100% !important;
  justify-content: center ;
}
.pricing-section .pricing-slider .slick-slide{
  width: 300px !important;
}
.ielts-btn{
  left: 0 !important;
  right: 0 !important;
}
.btn-here{
  width: 60%;
  margin: 0 20%;
}
.ielts-card{
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  border: none !important;
}

@media screen and (max-width:425px) {
  .pricing-section .pricing-slider .slick-track{
  width: 1510px !important;
  justify-content: center ;
}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Ielts.vue